<script>
import numberMixin from "@/mixins/numberMixin";
import { mapActions } from "vuex";
import moment from "@/utils/moment";
import newOrderHelper from "@/utils/helpers/newOrder";

export default {
  mixins: [numberMixin],
  data() {
    return {
      preloader: false,
      coupon_text: "",
      error: ""
    };
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    discountPercentage: () => newOrderHelper.getDiscountPercentage()
  },
  methods: {
    ...mapActions("coupons", ["getCouponByName"]),
    ...mapActions("orders", ["checkIfCouponApplies", "applyCoupon"]),

    async checkCoupon() {
      this.preloader = true;

      const valid10OffCoupon = (couponName, orderStartsAt) => {
        let dayOfWeek = moment(orderStartsAt).day();
        let acceptDaysOfWeek = [2, 3];
        let is10OffCoupon = couponName.toUpperCase() === "10OFF";
        let hasValidDate = !acceptDaysOfWeek.includes(dayOfWeek);

        return is10OffCoupon && hasValidDate;
      };

      const invalidPurpleWeekCoupon = (couponName, orderStartsAt) => {
        let purpleWeekCoupons = [
          "TERCAROXA5",
          "QUARTAROXA7",
          "QUINTAROXA7",
          "SEXTAROXA10"
        ];
        let beforeLimitDate = moment(orderStartsAt) < moment("2020-12-01");
        let isPurpleWeekCoupon = purpleWeekCoupons.includes(
          couponName.toUpperCase()
        );

        return isPurpleWeekCoupon && !beforeLimitDate;
      };

      try {
        if (
          valid10OffCoupon(
            this.coupon_text,
            this.order.schedule_event.starts_at
          )
        )
          throw "O cupom só pode ser aplicado em limpezas que ocorrerão em terças-feiras ou quartas-feiras.";

        if (
          invalidPurpleWeekCoupon(
            this.coupon_text,
            this.order.schedule_event.starts_at
          )
        )
          throw "O cupom só pode ser aplicado em limpezas que ocorrerão até dia 30/11/2020.";

        let coupon = await this.getCouponByName(this.coupon_text);

        let data = {
          order: this.$route.params.order_id,
          coupon: coupon.id
        };

        await this.checkIfCouponApplies(data);
        await this.applyCoupon(data);
        this.$emit("couponApplied");
        this.error = "";
      } catch (e) {
        this.error = e;
      }

      this.preloader = false;
    },

    isProfessionalsBeginnerCoupon: order =>
      order.coupon_id === newOrderHelper.getCouponID()
  }
};
</script>

<template>
  <div v-if="order">
    <div class="with-border pt-15 pb-15">
      <div class="d-flex">
        <div>
          <div class="sub-title">
            CUPOM PROMOCIONAL
            <span class="italic">
              /
              <span v-if="order.coupon">
                <template v-if="isProfessionalsBeginnerCoupon(order)">
                  já foi aplicado
                  <b>{{discountPercentage}}% de desconto</b> ao pedido
                </template>

                <template v-else>
                  o cupom
                  <b>{{order.coupon.name}}</b> foi aplicado
                </template>
              </span>
              <span v-else>aplique o cupom</span>
            </span>
          </div>

          <form v-if="!order.coupon" @submit.prevent="checkCoupon">
            <input
              v-model="coupon_text"
              type="text"
              placeholder="informe o cupom"
              class="coupon-input"
            />
            <button
              type="submit"
              class="btn bg-pink coupon-button"
              :class="{'btn--loading': preloader}"
            >
              <span>APLICAR</span>
            </button>
          </form>
        </div>

        <div class="pricing">
          <span
            class="price"
            v-if="order.coupon"
          >- {{order.amount.subtotal.discount | intToCurrency}}</span>
        </div>
      </div>

      <div class="warning" v-if="error">{{error}}</div>
    </div>

    <div class="total with-border pt-15 pb-15">
      <div class="sub-title">Total</div>

      <div class="pricing">
        <span class="price">{{order.amount.total | intToCurrency}}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.with-border {
  border-bottom: 1px solid #ddd;
}

.d-flex {
  justify-content: space-between;
}

.warning {
  border-left: 1px solid var(--pink);
  color: var(--pink);
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  margin: 10px 5px 0;
  padding: 3px 7px;
}

.pricing {
  font-size: 20px;
  font-weight: bold;
}

.pricing .price {
  font-size: 20px;
  color: var(--pink);
  white-space: nowrap;
}

.sub-title {
  font-size: 16px;
  font-weight: 700;
}

.italic {
  font-weight: 300;
  font-style: italic;
  font-size: 16px;
  color: #999;
}

.coupon-input {
  background: url("/static/cupom.svg") no-repeat 10px 10px;
  background-size: 20px 17px;
  border: 1px solid #ddd;
  height: 35px;
  margin-top: 15px;
  width: 305px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding-left: 35px;
  float: left;
  text-transform: uppercase;
}

.coupon-input::placeholder {
  text-transform: lowercase;
}

.coupon-button {
  width: 90px;
  height: 39px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  float: left;
  margin-top: 15px;
  margin-left: 0;
  font-weight: 500;
}

.coupon-button:hover {
  background-color: var(--pink-dark);
}

.total {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

@media (max-width: 620px) {
  .cupom-input {
    width: 188px;
    border-radius: 4px;
  }
}

@media (max-width: 540px) {
  .coupon-input {
    width: calc(100% - 38px);
    border-radius: 4px;
  }

  .coupon-button {
    width: 100%;
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/Coupon.vue